import { Link, usePage } from "@inertiajs/react";
import Container from "../../components/Container";
import MainLayout from "../../components/MainLayout";
import { PageProps } from "../../types";

const NotFound = () => {
  const { props } = usePage<PageProps>();

  return (
    <MainLayout {...props}>
      <Container className="flex flex-col items-center justify-center text-center py-20">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <h2 className="text-2xl font-semibold mt-4 mb-2">
          Página No Encontrada
        </h2>
        <p className="text-muted-foreground mb-6">
          Lo sentimos, la página que 3 buscas no existe o ha sido movida.
        </p>
        <Link
          href="/"
          className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        >
          Volver al Inicio
        </Link>
      </Container>
    </MainLayout>
  );
};

export default NotFound;
